import { render, staticRenderFns } from "./bindSuccess.vue?vue&type=template&id=239b184a&scoped=true"
import script from "./bindSuccess.vue?vue&type=script&lang=js"
export * from "./bindSuccess.vue?vue&type=script&lang=js"
import style0 from "./bindSuccess.vue?vue&type=style&index=0&id=239b184a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239b184a",
  null
  
)

export default component.exports